import { AutogenModelMbDetailHist, AutogenRowMbDetailHist } from "./autogen/AutogenModelMbDetailHist";

export class ModelMbDetailHist extends AutogenModelMbDetailHist<RowMbDetailHist> {
	constructor() {
		super(RowMbDetailHist);
	}
}

export class RowMbDetailHist extends AutogenRowMbDetailHist {
}
